// Not Found Page
import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
const NotFound = () => {
  const {t} = useTranslation();
  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Typography variant="h1" gutterBottom>
        {/* 404 */}
        {t('NotFound.title')}
      </Typography>
      <Typography variant="h4" gutterBottom>
        {/* Page Not Found */}
        {t('NotFound.subtitle')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {/* The page you are looking for might have been removed had its name changed or is temporarily unavailable. */}
        {t('NotFound.message')}
      </Typography>
      <a href="/" style={{ textDecoration: 'none' }}>
        {/* Go to Home Page */}
        {t('NotFound.homeLink')}
      </a>
    </Container>
  );
};

export default NotFound;